import React from 'react';
import { LicenseIconTag } from '../../modules/Icons';
import { LicenseeTagProps } from '../../types/components/products/LicenseeTag';


const LicenseeTag: React.FC<LicenseeTagProps> = ({ className, productId }) => {
  return (
    <div className={className}>
      <div data-tooltip-id={productId.toString()} className='bg-black bg-opacity-[60%] p-1.5 rounded-[5px]'>
        <LicenseIconTag />
      </div>
    </div>
  )
}

export default LicenseeTag;